import { SelectLabelGroups } from '~settings/components/SelectLabelGroups';
import { SelectUserRole } from '~settings/components/SelectUserRole';

interface InternalPermissionsProps {
  name: string;
}

export function InternalPermissions({ name }: InternalPermissionsProps) {
  return (
    <div className="grid grid-cols-3 items-start gap-md">
      <SelectUserRole
        multiselect
        name={`${name}.roles`}
        targetUserType="INTERNAL"
      />
      <SelectLabelGroups name={`${name}.labelGroups`} />
    </div>
  );
}

InternalPermissions.displayName = 'InternalPermissions';
